import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [VIEW_TECH_RSLT, VIEW_TECH_RSLT_RSLT_SUCCESS, VIEW_TECH_RSLT_RSLT_FAILURE] =
  createRequestActionTypes('tech/VIEW_TECH_RSLT');
export const viewTechRslt = createAction(VIEW_TECH_RSLT, (id) => id);
const viewTechRsltSaga = createRequestSaga(VIEW_TECH_RSLT, techApi.getRsltInfo);

const UNLOAD_TECH_RSLT = 'tech/UNLOAD_TECH_RSLT';
export const unloadTechRslt = createAction(UNLOAD_TECH_RSLT);

const SET_TECH_RSLT = 'tech/SET_TECH_RSLT';
export const setTechRslt = createAction(SET_TECH_RSLT, (tech) => tech);


export function* techRsltSaga() {
  yield takeLatest(VIEW_TECH_RSLT, viewTechRsltSaga);
}

const initialState = {
  techReq:null,
  techPlan: null,
  techRslt:null,
  techRsltCostList:null,
  approvalList:null,
  apprUuid:null,
  message:null,
  error: null,
};

const techRslt = handleActions(
  {
    [VIEW_TECH_RSLT_RSLT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      techReq: data.info.techReq,
      techPlan: data.info.techPlan,
      techRslt: data.info.techRslt,
      techRsltCostList: data.info.techRsltCostList,
      approvalList: data.info.approvalList,
      apprUuid: data.info.apprUuid,
      message: data.info.message,
    }),
    [VIEW_TECH_RSLT_RSLT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_TECH_RSLT]: () => initialState,
    [SET_TECH_RSLT]: (state, { payload: data }) => ({
      ...state,
      techReq: data.techReq,
      techPlan: data.techPlan,
      techRslt: data.techRslt,
      techRsltCostList: data.techRsltCostList,
      approvalList: data.approvalList,
      apprUuid: data.apprUuid,
      
    }),
    
  },
  initialState,
);

export default techRslt;
